// This file stores all the constants in the application.
export enum QoSRouterPage {
    AddOperation = 'add-operation',
    ManageIKey = 'manage-ikey',
    Admin = 'admin'
}
